export default __webpack_public_path__ + "static/media/11.22.49403ae9.jpg";